import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'anoNie',
    standalone: false
})
export class AnoNiePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: boolean): string {
    return this.translate.instant(value ? 'Ano' : 'Nie');
  }

}
